import { LeaderboardTable } from '../leaderboard/LeaderboardTable';
import type { LeaderboardEntry } from '../leaderboard/LeaderboardTable';
import { LeaderboardOptInNotice } from '../leaderboard/LeaderboardOptInNotice';

export interface LeaderboardTabsProps {
  entries: LeaderboardEntry[];
  currentUserId?: string | null;
  /** Persisted opt-in (public profile + authority scores shown); null = unknown. */
  isOptedIn: boolean | null;
  currentUserRank: number | null;
}

/**
 * The community leaderboard section of the Progress page. The data is the
 * global board from GET /gamification/leaderboard (opted-in users only).
 */
export function LeaderboardTabs({
  entries,
  currentUserId,
  isOptedIn,
  currentUserRank,
}: LeaderboardTabsProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Community Leaderboard</h3>
        <p className="text-sm text-gray-500">
          See how you stack up against other speakers who share their scores
        </p>
      </div>

      <LeaderboardOptInNotice isOptedIn={isOptedIn} currentUserRank={currentUserRank} />

      <LeaderboardTable
        entries={entries}
        currentUserId={currentUserId}
        showDomain={false}
        showBadges={false}
        showHireStatus={false}
      />

      <p className="text-xs text-gray-400 text-center">
        Ranked by average overall score across scored practice sessions.
      </p>
    </div>
  );
}
